import { UserActivityStats } from "../../../models/DashboardStats";

/** Sum of every activity metric for a user, matching the table's row total. */
export function getUserActivityTotal(row?: UserActivityStats): number {
  if (!row) return 0;

  return (
    (row.booked ?? 0) +
    (row.collected ?? 0) +
    (row.depollutedCount ?? 0) +
    (row.crushedCount ?? 0) +
    (row.dismantlingListsCreated ?? 0) +
    (row.createdCount ?? 0) +
    (row.removedCount ?? 0) +
    (row.imagedCount ?? 0) +
    (row.locatedCount ?? 0) +
    (row.pricedCount ?? 0) +
    (row.listedCount ?? 0) +
    (row.pickedCount ?? 0) +
    (row.shippedCount ?? 0) +
    (row.scrappedCount ?? 0) +
    (row.deletedCount ?? 0) +
    (row.damagedCount ?? 0)
  );
}
